export const jobs = {
  steps: {
    general: 'General',
    vehicle: 'Vehicle',
    location: 'Location',
    notes: 'Notes',
    notes_and_files: 'Notes & Files',
    signature: 'Property Manager Signature Required',
  },
  buttons: {
    scan_plate: 'Scan Plate',
    vin_lookup: 'Lookup VIN',
    plate_lookup: 'Lookup Plate',
    review_job: 'Review Job',
  },
  helpers: {
    vin_lookup: 'Auto-fill vehicle information by looking up the VIN',
    scan_plate:
      'Auto-fill vehicle information with a photo of the license plate',
    plate_lookup:
      'Auto-fill vehicle information by looking up the license plate',
    vehicle_step: 'A license plate or vin is required',
    no_violations:
      'Select a property and job type to select from violations defined in the property rules',
    signature_step:
      'The job will be created pending approval from the property manager if no signature is provided',
  },
  dialogs: {
    vin_verify: {
      title: 'Verify VIN',
      description:
        'To continue, we ask that you verify the last {{charactersToVerify}} characters of VIN. Click OK to proceed',
    },
    approval: {
      approve: 'Approve {{type}}',
      deny: 'Deny {{type}}',
      menu: 'Review {{type}}',
      header: 'Property Manager Signature Required',
      denial_reason: 'Reason for denial',
    },
    do_not_tow: {
      title: 'Warning! {{type}} Restriction',
      reason: 'Reason for overriding restriction',
      override: 'Override Restriction',
    },
    cancel: {
      header: 'Cancel {{type}} Job',
      body: 'This will cancel the job request and cannot be undone.',
      reason: 'Cancellation reason',
      reasons_error: 'Failed to load cancellation reasons',
      confirm: 'Cancel Job',
      keep: 'Keep Job',
    },
  },
  labels: {
    live_status: 'Live Status',
    location_notes: 'Location Notes',
    address_lookup: 'Address Lookup',
    created_by: 'Created By',
    property_group_select: 'Filter by Property Group',
    cancellation_reason: 'Cancellation Reason',
  },
};

export default jobs;
